import Vue from 'vue'
import axios from 'axios'
import Vuex from "vuex";

import store from "./datastore/vuexDataStore.js";

var contactForm = new Vue({
  store: store,
  el: '#vuecontactform',
  data: {
    name: '',
    email: '',
    phone: '',
    message: '',
    response: '',
    success: '',
    activeClass: 'active'
  },
  methods: {
    submitForm() {
      axios.post('/umbraco/api/contact/SubmitMessage', {
        Name: this.name,
        Phone: this.phone,
        Email: this.email,
        Message: this.message
       
      }).then(response => {
        // console.log(response);
        // this.response = response.data
        this.success = 'Tak for din besked';
        this.response = JSON.stringify(response, null, 2)
      }).catch(error => {
        this.response = 'Error: ' + error.response.status
      })
      this.name = '';
      this.email = '';
      this.phone = '';
      this.message = '';
    }
  }
})



// WEBPACK FOOTER //
// ./src/ContactForm.js